module.exports = __webpack_public_path__ + "img/404.9e1ef3aa.svg";